import React, { Component } from 'react';
import { TouchableOpacity } from 'react-native';
import Box from '../Box';

// ///////////////////////////////////////////////////////////////////

const BaseTouchable = Box.withComponent(TouchableOpacity);

export default class Touchable extends Component {
    get isDisabled() {
        return !this.props.onPress;
    }

    render() {
        return <BaseTouchable disabled={this.isDisabled} {...this.props} />;
    }
}
